import { ReactElement, Fragment } from 'react';
import { Outlet } from 'react-router-dom';

const Organisations = (): ReactElement => {
  return (
    <Fragment>
      <Outlet />
    </Fragment>
  );
};
export default Organisations;
